import cn from 'classnames';
import { ptBrCommon } from '@/lib/pt-br/messages';
import Link from '@/components/ui/link';

type SectionProps = {
  className?: any;
  title?: string;
  href?: string;
  children?: React.ReactNode;
  style?: any;
};

/**
 * UI component for a section block
 * @param {string} title - The title of the section
 * @param {string} description - The description of the section
 * @param {string} href - The href of the external page for this section
 */

const SectionBlock: React.FC<SectionProps> = ({
  className,
  title,
  href,
  children,
  style,
}) => {
return (
    <div
      className={cn(
        'flex w-full flex-col px-5 pb-[40px] lg:px-7 xl:px-10 xl:pb-[54px] 3xl:pb-[60px]',
        className,
      )}
    >
      {title && (
        <div className="mb-5 flex min-w-0 items-center justify-between gap-x-3">
          {title && (
            <h2
              style={style}
              className="min-w-0 flex-1 break-words text-2xl font-extrabold lg:text-[27px] 3xl:text-3xl"
            >
              {ptBrCommon(title)}
            </h2>
          )}
          {href && (
            <Link
              href={href}
              className="shrink-0 text-sm font-semibold transition-colors hover:text-orange-500 sm:text-base"
            >
              {"Ver Todos"}
            </Link>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default SectionBlock;
